import React from 'react';
import super1 from '../assets/super1.png';
import super2 from '../assets/super2.png';
import super3 from '../assets/super3.png';
import super4 from '../assets/super4.png';
import Card from './Card';

export default function SuperRare() {

  const data = [
    {
      image: super1,
      series: "Glopp Series",
      title: "Purple Man",
      price: 2.99,
      tag: 12983,
      time: 1,
    },
    {
      image: super2,
      series: "Series Check",
      title: "Purple Man",
      price: 2.99,
      tag: 12983,
      time: 1,
    },
    {
      image: super3,
      series: "Glopp Series",
      title: "Purple Man",
      price: 2.99,
      tag: 12983,
      time: 1,
    },
    {
      image: super4,
      series: "Glopp Series",
      title: "Purple Man",
      price: 2.99,
      tag: 12983,
      time: 1,
    }
  ]

  return (
    <div className='super-rare'>
      <div className="title-container">
        <h2 className="title">LE Super Rear Auction</h2>
        <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos ex amet itaque assumenda aliquam consequuntur similique repellat reprehenderit sit mollitia nobis fuga, placeat quisquam nulla, quam numquam laborum aperiam blanditiis.
          <a href='#'>OpenSea.</a>
        </p>
      </div>
      <div className="cards">
        {
          data.map((card) => 
          <Card image={card.image} series={card.series} title={card.title} price={card.price} tag={card.tag} time={card.time} />
          )
        }
      </div>
    </div>
  )
}
